import { render, staticRenderFns } from "./DbTableIcon.vue?vue&type=template&id=6d5c88fb&"
import script from "./DbTableIcon.vue?vue&type=script&lang=js&"
export * from "./DbTableIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports